module.exports = __webpack_public_path__ + "static/5-01ca90c091753411b5a938b86fd6dc1f.jpg";